export default {
      id: "playslide-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.479460d5.svg#playslide",
      toString: function () {
        return this.url;
      }
    }